import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { UserInfoEffects } from './store/effects/user-info.effects';
import { userInfoReducer } from './store/reducers/user-info.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('userInfo', userInfoReducer),
    EffectsModule.forFeature([UserInfoEffects]),
  ],
})
export class UserInfoModule {}
